import { createSlice } from "@reduxjs/toolkit";
import { DColumns } from "../../actions/data/DataDeclarations";

import { SiteUsersConfigRows } from "../../actions/users/userTypes";
import { logOut } from "../layout";

export interface AssignedSite {
  name: string;
  id: number;
}

export interface ManagerUsersConfigRows {
  assignedSite: AssignedSite | null;
  assignedGroups: number[];
  // assignedSite: number[];
  email: string;
  id: number;
  isNew: boolean;
  role: number | undefined | string;
  groupsLocationsSelectedIds?: number[];
  groupsSelected?: GroupStructure[];
}

export interface GroupStructure {
  createdAt: string | null;
  deletedAt: string | null;
  groupTemplateId: number;
  id: number;
  isAutoGenerated: boolean;
  name: string;
  orgId: number;
  typeId: number;
  updatedAt: null | string;
  locations: number[];
}

export interface CreateUsersStep {
  step: number;
  option: string;
  place: string;
  UsersValidate: boolean;
}

export interface CreateUsersQuantity {
  numberOfUserToCreate: number;
  usersNames: string;
  usersToCreate: string[];
}

export interface GroupTemplateRaw {
  createdAt: string;
  updatedAt: string;
  id: number;
  name: string;
  description: null | string;
  defaultMembershipType: number;
  defaultTypeId: null | number;
}

export interface CreateUsersState {
  createUserSteps: CreateUsersStep;
  createUsers: CreateUsersQuantity;
  searchValues: {
    sites: string;
    actions: string;
  };
  error: string;
  errorCreateUsers: string;
  errorCreateLocations: string;
  usersConfigRows: SiteUsersConfigRows[];
  rowsAlpha: SiteUsersConfigRows[];
  columns: any[];
  actionsValues: any[];

  tryingToCreateSomething: boolean;
  theMaximumNumberIntheUsernamesCreations: number;
  verifyIfAllIsCreated: {
    createdUsers: boolean;
    linkActions: boolean;
    usersCreated: number;
  };
  loading: boolean;
  partialSuccessModal: {
    open: boolean;
    createdUsernames: string[];
  };
}

export const initialState: CreateUsersState = {
  createUserSteps: {
    step: 0,
    option: "",
    place: "",
    UsersValidate: true,
  },

  createUsers: {
    numberOfUserToCreate: 0,
    usersNames: "",
    usersToCreate: [],
  },

  searchValues: {
    sites: "",
    actions: "",
  },

  usersConfigRows: [],
  rowsAlpha: [],
  columns: [
    {
      field: "id",
      sortable: true,
      width: 100,
      alwaysHide: true,
    },

    {
      field: "username",
      sortable: true,
      width: 200,
      alwaysHide: false,
    },
    {
      field: "assignedSite",
      sortable: false,
      width: 240,
      alwaysHide: false,
    },
    {
      field: "assignedAction",
      sortable: false,
      width: 240,
      alwaysHide: false,
    },

    {
      field: "nomadUser",
      sortable: false,
      width: 200,
      alwaysHide: false,
    },
    {
      field: "actions",
      sortable: false,
      width: 200,
      alwaysHide: false,
    },
  ] as DColumns[],
  error: "",
  errorCreateLocations: "",
  errorCreateUsers: "",
  actionsValues: [{ name: "", id: 0 }],

  tryingToCreateSomething: false,
  theMaximumNumberIntheUsernamesCreations: 0,
  verifyIfAllIsCreated: {
    createdUsers: false,
    linkActions: false,
    usersCreated: 0,
  },

  loading: false,
  partialSuccessModal: {
    open: false,
    createdUsernames: [],
  },
};

export const CreateUsersSlice = createSlice({
  name: "CreateUsersReducer",
  initialState,
  reducers: {
    setVerifyAllIsCreated(state, actions) {
      return {
        ...state,
        verifyIfAllIsCreated: actions.payload,
      };
    },
    setMaximumNumberFromUserCreations(state, action) {
      return {
        ...state,
        theMaximumNumberIntheUsernamesCreations: action.payload,
      };
    },
    setTryingToCreateSomething(state, action) {
      return { ...state, tryingToCreateSomething: action.payload };
    },

    setCreateUsersStep(state, action) {
      return {
        ...state,
        createUserSteps: action.payload,
      };
    },
    setCreateUsers(state, action) {
      return {
        ...state,
        createUsers: action.payload,
      };
    },

    setRowsAlpha(state, action) {
      return {
        ...state,
        rowsAlpha: action.payload,
      };
    },
    setUserConfigRows(state, action) {
      return {
        ...state,
        usersConfigRows: action.payload,
      };
    },
    setColumns(state, action) {
      return {
        ...state,
        columns: action.payload,
      };
    },

    setPartialSuccessModal(state, action: { payload: { open: boolean; createdUsernames: string[] } }) {
      return {
        ...state,
        partialSuccessModal: action.payload,
      };
    },

    resetStateCreateUsers() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logOut, () => {
      return initialState;
    });
  },
});

export const {
  setVerifyAllIsCreated,
  setMaximumNumberFromUserCreations,
  setCreateUsersStep,
  setCreateUsers,
  setColumns,
  setRowsAlpha,
  setUserConfigRows,
  resetStateCreateUsers,
  setTryingToCreateSomething,
  setPartialSuccessModal,
} = CreateUsersSlice.actions;

export const CreateUsers = CreateUsersSlice.reducer;
